import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopNavigationComponent } from '@web/common';
import { FooterComponent } from '../../footer/component';
import { SideNavigationComponent } from '../side-navigation/component';

@Component({
  selector: 'cas-main',
  template: `
    <cas-top-navigation (menuToggle)="sideNavigation.toggle()"></cas-top-navigation>
    <div class="d-flex">
      <cas-side-navigation
        #sideNavigation
        class="col-auto"
        (width)="leftMargin = $event"></cas-side-navigation>
      <main
        #main
        class="d-flex flex-column w-100 h-100 justify-content-between align-items-center">
        <router-outlet></router-outlet>
        <footer
          #footer
          class="align-self-stretch">
          <cas-footer></cas-footer>
        </footer>
      </main>
    </div>
  `,
  styles: [
    `
      div ::ng-deep {
        main {
          min-height: calc(100vh - 64px);

          & > footer,
          cas-footer {
            @media (width < 1400px) {
              margin-left: 72px;
            }
            @media (width <= 576px) {
              margin-left: 0;
            }
          }
        }
      }
    `,
  ],
  imports: [TopNavigationComponent, SideNavigationComponent, RouterOutlet, FooterComponent],
})
export class MainComponent {
  @ViewChild('footer', { static: true }) footer!: ElementRef<HTMLElement>;

  leftMargin = 0;
}
